export default {"src":"/_next/static/media/goal.4db04eb8.svg","height":357,"width":450};